import axiosClient from "./axiosClient";

const contentServiceApi = {
  getById: (id) => {
    const url = `api/content/${id}`;
    return axiosClient.get(url, id);
  },

  getBySlug: (slug) => {
    const url = `api/content/${slug}/slug`;
    return axiosClient.get(url, slug);
  },

  getAll: () => {
    const url = `api/content/getall`;
    return axiosClient.get(url);
  },

  getAppConfig: () => {
    const url = `api/app/app-config`;
    return axiosClient.get(url);
  },

  createContent: (data) => {
    const url = `api/content`;
    return axiosClient.post(url, data);
  },

  updateContent: (id, data) => {
    const url = `api/content/${id}`;
    return axiosClient.put(url, data);
  },

  deleteContentById: (id) => {
    const url = `api/content/${id}`;
    return axiosClient.delete(url, id);
  },
};
export default contentServiceApi;
